export default {
  zh: {
    lastText:'上周第一',
    share: '分享至',
    link: '我在App和朋友一起聊天，请来加入我们吧! ',
    timeR: '倒计时: ',
    title: '周星礼物',
    user: '用户',
    room: '房间',
    reward: '奖励',
    ruleText: '规则',
    rule:
      '1.本周活动周期为KSA时间周一00:00至周日23:59:59。<br/><br/>' +
      '2.用户可以通过每周赠送明星礼品获得积分。<br/><br/>' +
      '3.奖励将于每周一0:00自动发放。<br/><br/>' +
      '4.每个用户每周最多可获得一枚奖牌。<br/><br/>' +
      '5.奖牌有效期为7天。获得3次可升级为永久奖牌。<br/><br/>' +
      // '6.如果用户赢得全部的礼物第一名，则他获得奖金为200k*4，每个礼物的贡献值必须大于150k<br/>' +
      // '7.关于奖金：每个礼物都有3名获奖者，其中200k的奖金需要赢得第一名，并且贡献在150k以上，如果贡献没有达到150k，例如贡献只有120k，则获得150k的奖励<br/>' +
      // '8.如果用户作为第三名，但他的贡献没有达到80k，则无法获得100k的奖励<br/>' +
      '6.周星礼物不计入其他活动积分等级。<br/><br/>' +
      '7.在四个礼物中花费最多金币的获胜者的照片在周星中显示。<br/><br/>' +
      '8.本活动版权归App所有。',
    groupMedal: '7天',
    roomMedal: '房间勋章',
    lastWeek: '上一周',
    totalgift: 'Total of all gifts',
    service: '如果您有任何疑问，请点击此处联系客户服务Ahlam.',
    rewardtitle: '奖励规则',
    rewardRule: `
    - 关于头饰和汽车：你可以拿头饰和汽车，无论用户赢得哪个位置。<br/><br/>
    - 关于徽章：徽章只能在完成用户获胜位置的积分的情况下领取，其他中心不能兑换任何其他徽章。<br/><br/ >
    - 关于硬币：如果用户赢得了其中一个中心，例如（用户赢得了第一名，但他的积分，例如500k，意味着低于800k，这是获得硬币的要求，在这种情况下他会拿第一名的头饰+第一名的车+第一名的徽章+他可以得到第二名的硬币，因为他满足了获得第二名硬币的条件，超过400k）。<br/ ><br/>
    但是如果他在第一名的积分低于500k，例如400k意味着比第一名徽章的积分还少，这种情况下，他将获得头饰和汽车作为第一名并且只有第二名的硬币，这意味着没有徽章的奖励。
    `
},
  en: {
    lastText:'No.1 Last Week',
    share: 'Share to',
    link: 'Come join me at App. ',
    timeR: 'Count down: ',
    title: 'weekly gift',
    user: 'User',
    room: 'Room',
    reward: 'Reward',
    ruleText: 'Rule',
    rule:
      '1. Weekly activity cycle is from Monday 00:00 to Sunday 23:59:59 KSA time.<br/><br/>' +
      '2. Users can earn points by giving star gifts every week.<br/><br/>' +
      '3. Rewards are automatically issued at 00:00 every Monday.<br/><br/>' +
      '4. Each user has a max of one medal per week<br/><br/>' +
      '5. Medals are valid for 7 days. Upgrade your medals permanently after receiving 3 consecutive times.<br/><br/>' +
      // '6. If the user wins the first place in all gifts, his bonus will be equivalent 200k*4, and the contribution value of each gift must be greater than 150k<br/>' +
      // '7. About the bonus: There are 3 winners for each gift, of which the bonus of 200k needs to win the first place, and the contribution is above 150k, if the contribution does not reach 150k, for example, the contribution is only 120k, then the reward of 150k will be awarded<br/>' +
      // '8. If the user is the third, but his contribution does not reach 80k, he cannot get the reward of 100k<br/>' +
      '6. weekly activity gifts do not count towards other activity points.<br/><br/>' +
      '7. The winner who spends the most coins in the four gifts is the winner whose picture is displayed in the weekly star<br/><br/>' +
      '8. The copyright of this activity belongs to App. Question or concerns please contact ID 1 or ID 2.',
    groupMedal: '7 Days',
    roomMedal: 'Room Medals',
    lastWeek: 'Last Week',
    totalgift: 'Total of all gifts',
    service: 'If you have questions, please click here to contact customer service.',
    rewardtitle: 'Reward',
    rewardRule: `
    - Regarding the headwear and the car : You can take a headwear and a car, whichever position the user won.<br/><br/>
    - Regarding the badge: The badge can only be taken in the case of completing the points of the position in which the user won, and it cannot be exchanged for any other badge for the rest of the centers.<br/><br/>
    - Regarding the coins: in the event that the user wins one of the centers, for example (a user won the first place, but his points, for example, 500k, means less than 800k, which are the requirements to obtain coins, in this case he will take the first place headwear + the first place car + the first place badge + and he can get  for second-place coins because he met the condition for second-place coins, which is more than 400k).<br/><br/>
    - But in the event that he was a winner in the first place with less than 500k points, for example, 400k means less even than the points of the first badge , In this case, he will take the headwear and the car for the first place and the second place coins only, which means rewards without a badge.<br/><br/>
    - Different countries such as Turkey and Arabia belong to different rankings.
    `
  },
  ar: {
    lastText:'No.1 Last Week',
    share: 'Share to',
    link: 'Come join me at App. ',
    timeR: 'العد التنازلي ',
    title: 'هدية أسبوعية',
    user: 'اشترك',
    room: 'غرفة .',
    reward: 'مكافأة',
    ruleText: 'حكم',
    rule:
      '1. تبدأ دورة النشاط الأسبوعي من الاثنين 00:00 إلى الأحد 23:59:59 بتوقيت المملكة العربية السعودية.<br/><br/>' +
      '2. يمكن للمستخدمين ربح نقاط من خلال تقديم هدايا النجوم كل أسبوع.<br/><br/>' +
      '3. يتم إصدار المكافآت تلقائيًا في تمام الساعة 00:00 كل يوم إثنين.<br/><br/>' +
      '4. كل مستخدم لديه شارة واحدة في الأسبوع كحد أقصى<br/>' +
      '5. الشارات صالحة لمدة 7 أيام . قم بترقية شارتك بشكل دائم بعد استلامها 3 مرات متتالية.<br/><br/>' +
      // '6. إذا فاز المستخدم بالمركز الأول في جميع الهدايا ، فستكون مكافأته 200 ألف *4 ، لكن بشرط أن تكون قيمة المساهمة لكل هدية أكبر من 150 ألف كونز<br/>' +
      // '7. حول المكافأة: <br/>هناك 3 فائزين لكل هدية ، يجب أن تكون المكافأة 200 ألف كونز  للفوز بالمركز الأول ، لكن بشرط ان تكون المساهمة أعلى من 150 ألف كونز ،<br/> إذا لم تصل المساهمة إلى 150 ألفًا ، على سبيل المثال ، كانت المساهمة 120 ألفًا فقط ، فسيتم منح مكافأة قدرها 150 ألفًا <br/>' +
      // '8. إذا كان المستخدم هو الثالث ولكن مساهمته لا تصل إلى 80.000 كونز لا يمكنه الحصول على مكافأة قدرها 100.000 كونز<br/>' +
      '6. هدايا النشاط الأسبوعية لا تحتسب ضمن نقاط النشاط الأخرى.<br/><br/>' +
      '7. تعود ملكية حقوق الطبع والنشر لهذا النشاط إلى App.  <br/>أي سؤال أو استفسارات ، يرجى الاتصال بالأيدي 1 أو الأيدي 2.<br/><br/>' +
      '8. الفائز الذي أنفق اكبر عدد من الكونزات في الهداياء الاربعة هو الفائز الذي يتم عرض صورته في النجم الاسبوعي',
    groupMedal: '7 أيام ',
    roomMedal: ' شارات الغرف ',
    lastWeek: 'في الأسبوع الماضي',
    totalgift: 'مجموع كل الهدايا',
    service: 'إذا كانت لديك اي مشكله  ، يرجى النقر هنا للتواصل مع خدمة العملاء أحلام ',
    rewardtitle: 'جائزة',
    rewardRule: `- فيما يتعلق بغطاء الرأس والسيارة: يمكنك أخذ غطاء الرأس والسيارة، أيًا كان الوضع الذي فاز به المستخدم.<br/><br/>
    - بخصوص الشارة: لا يمكن أخذ الشارة إلا في حالة استكمال نقاط المركز الذي فاز فيه المستخدم، ولا يمكن استبدالها بأي شارة أخرى لبقية المراكز.<br/><br/ >
    - فيما يتعلق بالعملات المعدنية: في حالة فوز المستخدم بأحد المراكز مثلا (مستخدم فاز بالمركز الأول ولكن نقاطه مثلا 500 ألف يعني أقل من 008 ألف وهي متطلبات الحصول على العملات المعدنية، في في هذه الحالة سيحصل على غطاء الرأس بالمركز الأول + سيارة المركز الأول + شارة المركز الأول + ويمكنه الحصول على عملات المركز الثاني لأنه استوفى شرط عملات المركز الثاني وهو أكثر من 400 ألف).<br/ <br/>
    - لكن في حال كان فائزاً بالمركز الأول بأقل من 005 ألف نقطة مثلاً 004 ألف يعني أقل حتى من نقاط الشارة الأولى، في هذه الحالة سيأخذ غطاء الرأس والسيارة للمركز الأول المركز والمركز الثاني عملات معدنية فقط، مما يعني جوائز بدون شارة.<br/><br/>
    - دول مختلفة مثل تركيا والجزيرة العربية تنتمي إلى تصنيفات مختلفة.`,
  },
  tr: {
    lastText:'Geçen Hafta 1.',
    share: 'Davet İçin Link Paylaşın',
    link: 'Come join me at App. ',
    timeR: 'Kalan süre: ',
    title: 'hafta hediye',
    user: 'Kişiler',
    room: 'Odalar',
    reward: 'Ödüller',
    ruleText: 'Kurallar',
    rule:
      "1- Haftalık Etkinlik Döngüsü Türkiye saati ile Pazartesi 00:00'dan Pazar 23:59:59 Saatine Kadardır.<br/><br/>" +
      '2. Kullanıcılar her hafta yıldız hediyeleri vererek puan kazanabilirler.<br/><br/>' +
      "3. Ödüller otomatik olarak her Pazartesi 00:00'da verilir.<br/><br/>" +
      '4. Her kullanıcının haftada en fazla bir madalyası vardır<br/><br/>' +
      '5. Madalyalar 7 gün geçerlidir. Art arda 3 kez madalya aldıktan sonra madalyalarınızı kalıcı olarak yükseltin.<br/><br/>' +
      // "6. Kullanıcı tüm hediyelerde birinciliği kazanırsa, bonusu 200k*4 eşdeğeri olacaktır ve her bir hediyenin katkı değeri 150k'dan fazla olmalıdır.<br/>" +
      // "7. Bonus hakkında: Her hediye için 3 kazanan var, bunlardan 200k bonusun ilk etapta kazanması gerekiyor ve katkı 150k'nın üzerinde, katkı 150k'ya ulaşmazsa, örneğin katkı sadece 120k, o zaman 150 bin ödül verilecek<br/>" +
      // "8. Kullanıcı üçüncü ise, ancak katkısı 80k'ya ulaşmazsa, 100k ödülünü alamaz.<br/>" +
      '6. haftalık aktivite hediyeleri diğer aktivite puanlarına dahil değildir.<br/><br/>' +
      '7. Dört hediyede en çok parayı harcayan kazanan, resmi haftalık yıldızda gösterilen kazanandır.',
    groupMedal: '7 Days',
    roomMedal: 'Oda Medalları',
    lastWeek: 'Geçen Haftalar',
    totalgift: 'Total of all gifts',
    service: 'Sorularınız varsa lütfen servisle iletişime geçmek için buraya tıklayın',
    rewardtitle: 'Ödül',
    rewardRule: `- Çerçeve ve Araç: Kullanıcı kaçıncı sıralamayı kazanırsa kazansın, bir çerçeve ve araç alabilir.<br/><br/>
    - Rozet:Yalnızca kullanıcının kazandığı sıralama puanlarının tamamlanması durumunda alınabilir, diğer sıralama ödülleri ile ve başka bir rozetle değiştirilemez.<br/><br/ >
    - Altın: Kullanıcının Sıralamalardan birini kazanması durumunda, örneğin (bir kullanıcı birinciliği kazandı, ancak puanı, örneğin 500k, Altın desteği alabilmek için gerekli olan 800k dan az anlamına gelir) bu durumda birincilik çerçevesi + birincilik aracı + birincilik rozetini + alacak ve 400k dan fazla olan ikincilik Altın desteği şartını yerine getirdiği için ikincilik sıralamasındaki altın desteğini alabilecek.<br/ ><br/>
    - Ancak ilk etapta 500k'dan az puanla kazanması durumunda, örneğin 400k, ilk rozetin puanından bile daha az anlamına gelir, Bu durumda ilk önce çerçeveyi ve aracı alacaktır. Yalnızca birincilik ve ikincilik Altını; bu da rozetsiz ödüller anlamına gelir.<br/><br/>
    - Türkiye ve Arabistan gibi farklı ülkeler, Ayrı ayrı kendi panellerindeki kullanıcılar ile  sıralamalarda yer alacaktır.
    `
  },
  jp: {
    lastText:'Geçen Hafta 1.',
    share: 'Share to',
    link: 'Come join me at App. ',
    timeR: 'カウントダウン: ',
    title: '週刊ギフト',
    user: 'ユーザー',
    room: 'へや',
    reward: '奨励する',
    ruleText: 'Rule',
    rule:
      '1.毎週のアクティビティ サイクルは、月曜 00:00 から日曜 23:59:59 KSA 時間です。<br/><br/>' +
      '2.ユーザーは毎週スターギフトを贈ることでポイントを獲得できます。<br/><br/>' +
      '3.報酬は毎週月曜日の 00:00 に自動的に発行されます。<br/><br/>' +
      '4.各ユーザーは 1 週間に最大 1 つのメダルを獲得できます<br/><br/>' +
      '5.メダルの有効期限は 7 日間です。パーマネントを 3 回連続して受け取ると、恒久的にアップグレードできます。<br/><br/>' +
      // '6.ユーザーがすべてのギフトで 1 位を獲得した場合、ボーナスは 200k*4 に相当し、各ギフトの貢献値は 150k 以上である必要があります<br/>' +
      // '7。ボーナスについて: ギフトごとに 3 人の当選者があり、そのうち 200k のボーナスが 1 位を獲得する必要があり、寄付が 150k を超えている場合、寄付が 150k に達しない場合、たとえば、寄付が 120k しかない場合は、 150,000 の報酬が授与されます<br/>' +
      // '8.ユーザーが 3 番目で、貢献度が 80,000 に達しない場合、100,000 の報酬を受け取ることはできません<br/>' +
      '6.ウィークリー アクティビティ ギフトは、他のアクティビティ ポイントにはカウントされません。<br/><br/>' +
      '「10、4つのプレゼントで最も多くのコインを使った勝者が、ウィークリースターに写真が表示された勝者です」',
    groupMedal: '7日',
    roomMedal: 'ルームメダル',
    lastWeek: '先週',
    totalgift: 'Total of all gifts',
    service: 'ご不明な点がございましたら、ここをクリックしてカスタマー サービス Ahlam にお問い合わせください。',
    rewardtitle: 'アワード',
    rewardRule: `
    - 帽子と車について : 帽子と車は、ユーザーが獲得した位置に関係なく取ることができます。<br/><br/>
    - バッジについて: バッジはユーザーが獲得したポジションのポイントを完了した場合にのみ取得でき、残りのセンターの他のバッジと交換することはできません.<br/><br/ >
    - コインについて: たとえば、ユーザーがセンターの 1 つを獲得した場合 (ユーザーは 1 位を獲得しましたが、彼のポイント、たとえば 500k は、コインを取得するための要件である 800k 未満を意味します。この場合、彼は 1 位の帽子 + 1 位の車 + 1 位のバッジ + を受け取り、2 位のコインの条件 (400k 以上) を満たしたので、2 位のコインを得ることができます)。 ><br/>
    しかし、彼が 500k ポイント未満で 1 位の勝者だった場合、たとえば 400k は最初のバッジのポイントよりも少ないことを意味します。この場合、彼は帽子と車を 1 位にします。 2 位はコインのみです。つまり、バッジのない報酬です。
    `
  },
  pt:{
    "lastText": "Nº 1 Semana Passada",
    "share": "Compartilhar para",
    "link": "Venha se juntar a mim no App.",
    "timeR": "Contagem regressiva: ",
    "title": "Presente semanal",
    "user": "Usuário",
    "room": "Sala",
    "reward": "Recompensa",
    "ruleText": "Regra",
    "rule":
      "1. O ciclo da atividade semanal vai de segunda-feira 00:00 até domingo 23:59:59, horário KSA.<br/><br/>" +
      "2. Os usuários podem ganhar pontos enviando presentes estelares toda semana.<br/><br/>" +
      "3. As recompensas são distribuídas automaticamente às 00:00 de cada segunda-feira.<br/><br/>" +
      "4. Cada usuário pode receber no máximo uma medalha por semana.<br/><br/>" +
      "5. As medalhas são válidas por 7 dias. Faça o upgrade permanente da medalha após recebê-la 3 vezes consecutivas.<br/><br/>" +
      "6. Os presentes da atividade semanal não contam para outros pontos de atividade.<br/><br/>" +
      "7. O vencedor que gastar mais moedas nos quatro presentes será aquele cuja foto será exibida na estrela semanal.<br/><br/>" +
      "8. Os direitos autorais desta atividade pertencem ao App. Para dúvidas ou preocupações, entre em contato com o ID 1 ou ID 2.",
    "groupMedal": "7 Dias",
    "roomMedal": "Medalhas da Sala",
    "lastWeek": "Semana Passada",
    "totalgift": "Total de todos os presentes",
    "service": "Se você tiver dúvidas, clique aqui para entrar em contato com o atendimento ao cliente.",
    "rewardtitle": "Recompensa",
    "rewardRule":
      "- Sobre o adereço de cabeça e o carro: Você pode obter um adereço de cabeça e um carro, dependendo da posição em que o usuário ganhou.<br/><br/>" +
      "- Sobre o emblema: O emblema só pode ser obtido se os pontos da posição vencida forem completados e não pode ser trocado por outro emblema dos demais centros.<br/><br/>" +
      "- Sobre as moedas: caso o usuário ganhe uma das posições, por exemplo (um usuário ficou em primeiro lugar, mas seus pontos foram 500k, ou seja, menos que os 800k necessários para obter moedas, ele receberá o adereço de cabeça de primeiro lugar + o carro de primeiro lugar + o emblema de primeiro lugar e poderá receber as moedas do segundo lugar, pois atendeu à condição de mais de 400k).<br/><br/>" +
      "- Porém, se ele vencer o primeiro lugar com menos de 500k pontos, por exemplo, 400k (menos do que os pontos do primeiro emblema), ele receberá o adereço de cabeça e o carro de primeiro lugar e apenas as moedas do segundo lugar, ou seja, recompensas sem emblema.<br/><br/>" +
      "- Países diferentes, como Turquia e Arábia, pertencem a classificações diferentes."
},
    id:{
    "lastText": "No.1 Minggu Lalu",
    "share": "Bagikan ke",
    "link": "Ayo bergabung dengan saya di App.",
    "timeR": "Hitung mundur: ",
    "title": "Hadiah mingguan",
    "user": "Pengguna",
    "room": "Ruangan",
    "reward": "Hadiah",
    "ruleText": "Aturan",
    "rule":
      "1. Siklus aktivitas mingguan berlangsung dari Senin 00:00 hingga Minggu 23:59:59 waktu KSA.<br/><br/>" +
      "2. Pengguna dapat memperoleh poin dengan memberikan hadiah bintang setiap minggu.<br/><br/>" +
      "3. Hadiah akan diberikan secara otomatis pada pukul 00:00 setiap hari Senin.<br/><br/>" +
      "4. Setiap pengguna hanya bisa mendapatkan satu medali per minggu.<br/><br/>" +
      "5. Medali berlaku selama 7 hari. Tingkatkan medali secara permanen setelah menerimanya 3 kali berturut-turut.<br/><br/>" +
      "6. Hadiah aktivitas mingguan tidak dihitung dalam poin aktivitas lainnya.<br/><br/>" +
      "7. Pemenang yang menghabiskan koin terbanyak untuk empat hadiah adalah pemenang yang fotonya akan ditampilkan di bintang mingguan.<br/><br/>" +
      "8. Hak cipta aktivitas ini dimiliki oleh App. Jika ada pertanyaan atau masalah, silakan hubungi ID 1 atau ID 2.",
    "groupMedal": "7 Hari",
    "roomMedal": "Medali Ruangan",
    "lastWeek": "Minggu Lalu",
    "totalgift": "Total semua hadiah",
    "service": "Jika Anda memiliki pertanyaan, klik di sini untuk menghubungi layanan pelanggan.",
    "rewardtitle": "Hadiah",
    "rewardRule":
      "- Tentang hiasan kepala dan mobil: Anda bisa mendapatkan hiasan kepala dan mobil sesuai dengan posisi yang dimenangkan pengguna.<br/><br/>" +
      "- Tentang lencana: Lencana hanya bisa diperoleh jika poin posisi yang dimenangkan telah terpenuhi, dan tidak dapat ditukar dengan lencana lain untuk posisi lainnya.<br/><br/>" +
      "- Tentang koin: Jika pengguna memenangkan salah satu posisi, misalnya (seorang pengguna memenangkan posisi pertama tetapi poinnya 500k, yang berarti kurang dari 800k yang dibutuhkan untuk mendapatkan koin, maka ia akan menerima hiasan kepala peringkat pertama + mobil peringkat pertama + lencana peringkat pertama dan juga bisa mendapatkan koin peringkat kedua karena telah memenuhi syarat dengan lebih dari 400k).<br/><br/>" +
      "- Namun, jika ia memenangkan posisi pertama dengan kurang dari 500k poin, misalnya 400k (yang berarti kurang dari poin untuk lencana pertama), maka ia hanya akan menerima hiasan kepala dan mobil untuk posisi pertama serta koin untuk posisi kedua, yang berarti hadiah tanpa lencana.<br/><br/>" +
      "- Negara yang berbeda, seperti Turki dan Arab, memiliki peringkat yang berbeda."
},
    uz:{
    "lastText": "No.1 O‘tgan Hafta",
    "share": "Ulashish",
    "link": "Menga App-da qo‘shiling.",
    "timeR": "Sanash: ",
    "title": "Haftalik sovg‘a",
    "user": "Foydalanuvchi",
    "room": "Xona",
    "reward": "Mukofot",
    "ruleText": "Qoidalar",
    "rule":
      "1. Haftalik faoliyat sikli dushanba 00:00 dan yakshanba 23:59:59 KSA vaqtigacha davom etadi.<br/><br/>" +
      "2. Foydalanuvchilar har hafta yulduz sovg‘alari yuborish orqali ball to‘plashlari mumkin.<br/><br/>" +
      "3. Mukofotlar har dushanba 00:00 da avtomatik ravishda beriladi.<br/><br/>" +
      "4. Har bir foydalanuvchi har hafta faqat bitta medal olishi mumkin.<br/><br/>" +
      "5. Medallar 7 kun davomida amal qiladi. 3 marta ketma-ket olganingizdan keyin medallar doimiy ravishda yangilanadi.<br/><br/>" +
      "6. Haftalik faoliyat sovg‘alari boshqa faoliyat ballariga qo‘shilmaydi.<br/><br/>" +
      "7. To‘rtta sovg‘aga eng ko‘p tanga sarflagan g‘olib haftalik yulduz sifatida namoyish etiladi.<br/><br/>" +
      "8. Ushbu faoliyatning mualliflik huquqi App-ga tegishli. Savollar yoki muammolar bo‘lsa, ID 1 yoki ID 2 bilan bog‘laning.",
    "groupMedal": "7 Kun",
    "roomMedal": "Xona Medallari",
    "lastWeek": "O‘tgan Hafta",
    "totalgift": "Barcha sovg‘alarning jami",
    "service": "Savollaringiz bo‘lsa, shu yerni bosing va mijozlarga xizmat ko‘rsatish bilan bog‘laning.",
    "rewardtitle": "Mukofot",
    "rewardRule":
      "- Bosh kiyim va mashina haqida: Foydalanuvchi qaysi o‘rinni egallagan bo‘lsa, o‘sha o‘rin bo‘yicha bosh kiyim va mashina olishi mumkin.<br/><br/>" +
      "- Nishon haqida: Nishon faqat foydalanuvchi yutgan o‘rin ballari to‘ldirilganda olinishi mumkin va boshqa o‘rinlar uchun nishonni almashtirish mumkin emas.<br/><br/>" +
      "- Tangalar haqida: Agar foydalanuvchi biror o‘rinni egallasa, masalan (foydalanuvchi birinchi o‘rinni oldi, lekin uning ballari 500k, ya’ni 800k dan kam bo‘lib, bu tangalarni olish uchun talab etiladi, bu holda u birinchi o‘rin bosh kiyimi + birinchi o‘rin mashinasi + birinchi o‘rin nishoni oladi va shuningdek, 400k dan yuqori bo‘lgani uchun ikkinchi o‘rin tangalarini olishi mumkin).<br/><br/>" +
      "- Agar u birinchi o‘rinni 500k dan kam ball bilan yutgan bo‘lsa, masalan, 400k (ya’ni birinchi nishon uchun talab qilingan ballardan kam), bu holda u faqat birinchi o‘rin bosh kiyimi va mashinasini hamda ikkinchi o‘rin tangalarini oladi, ya’ni nishonsiz mukofotlar.<br/><br/>" +
      "- Turkiya va Arabiston kabi turli davlatlar turli reytinglarga ega."
},
    ru:{
    "lastText": "№1 на прошлой неделе",
    "share": "Поделиться",
    "link": "Присоединяйтесь ко мне в App.",
    "timeR": "Обратный отсчет: ",
    "title": "Еженедельный подарок",
    "user": "Пользователь",
    "room": "Комната",
    "reward": "Награда",
    "ruleText": "Правила",
    "rule":
      "1. Еженедельный цикл активности длится с понедельника 00:00 до воскресенья 23:59:59 по времени KSA.<br/><br/>" +
      "2. Пользователи могут зарабатывать очки, отправляя звездные подарки каждую неделю.<br/><br/>" +
      "3. Награды выдаются автоматически в 00:00 каждого понедельника.<br/><br/>" +
      "4. Каждый пользователь может получить максимум одну медаль в неделю.<br/><br/>" +
      "5. Медали действительны в течение 7 дней. Улучшите свои медали навсегда после получения их 3 раза подряд.<br/><br/>" +
      "6. Еженедельные подарки не учитываются в других активностях.<br/><br/>" +
      "7. Победителем становится тот, кто потратил больше всего монет на четыре подарка, его фото отображается в еженедельной звезде.<br/><br/>" +
      "8. Авторские права на эту активность принадлежат App. По вопросам обращайтесь к ID 1 или ID 2.",
    "groupMedal": "7 дней",
    "roomMedal": "Медали комнаты",
    "lastWeek": "Прошлая неделя",
    "totalgift": "Общая сумма всех подарков",
    "service": "Если у вас есть вопросы, нажмите здесь, чтобы связаться со службой поддержки.",
    "rewardtitle": "Награда",
    "rewardRule":
      "- О головном уборе и автомобиле: Вы можете получить головной убор и автомобиль в зависимости от занятого пользователем места.<br/><br/>" +
      "- О значке: Значок можно получить только при выполнении условий по очкам для занятого места. Он не может быть обменян на другой значок.<br/><br/>" +
      "- О монетах: Если пользователь занял одно из мест, например, первое место, но его очки составляют 500k (что меньше 800k, необходимого для получения монет), в этом случае он получит головной убор за первое место, автомобиль за первое место, значок за первое место и сможет получить монеты за второе место, так как выполнил условие по очкам (более 400k).<br/><br/>" +
      "- Если пользователь занял первое место с менее чем 500k очков, например, 400k (что даже меньше, чем требуется для первого значка), в этом случае он получит головной убор и автомобиль за первое место, а также монеты за второе место, но без значка.<br/><br/>" +
      "- Разные страны, такие как Турция и Аравия, имеют разные рейтинги."
},
    fa:{
    "lastText": "شماره ۱ هفته گذشته",
    "share": "اشتراک‌گذاری",
    "link": "به من در اپلیکیشن بپیوندید.",
    "timeR": "شمارش معکوس: ",
    "title": "هدیه هفتگی",
    "user": "کاربر",
    "room": "اتاق",
    "reward": "پاداش",
    "ruleText": "قوانین",
    "rule":
      "۱. دوره فعالیت هفتگی از دوشنبه ساعت ۰۰:۰۰ تا یکشنبه ساعت ۲۳:۵۹:۵۹ به وقت KSA است.<br/><br/>" +
      "۲. کاربران می‌توانند با ارسال هدایا‌ی ستاره‌ای هر هفته امتیاز کسب کنند.<br/><br/>" +
      "۳. پاداش‌ها به صورت خودکار در ساعت ۰۰:۰۰ روز دوشنبه صادر می‌شوند.<br/><br/>" +
      "۴. هر کاربر حداکثر می‌تواند یک مدال در هفته دریافت کند.<br/><br/>" +
      "۵. مدال‌ها به مدت ۷ روز معتبر هستند. پس از دریافت ۳ بار متوالی، مدال خود را به صورت دائمی ارتقا دهید.<br/><br/>" +
      "۶. هدایا‌ی فعالیت هفتگی در امتیازات سایر فعالیت‌ها محاسبه نمی‌شوند.<br/><br/>" +
      "۷. برنده کسی است که بیشترین سکه را برای چهار هدیه خرج کند و تصویر او در ستاره هفتگی نمایش داده شود.<br/><br/>" +
      "۸. حقوق این فعالیت متعلق به اپلیکیشن است. برای سوالات یا نگرانی‌ها لطفاً با شناسه ۱ یا شناسه ۲ تماس بگیرید.",
    "groupMedal": "۷ روز",
    "roomMedal": "مدال‌های اتاق",
    "lastWeek": "هفته گذشته",
    "totalgift": "مجموع همه هدایا",
    "service": "اگر سوالی دارید، اینجا کلیک کنید تا با پشتیبانی مشتری تماس بگیرید.",
    "rewardtitle": "پاداش",
    "rewardRule":
      "- درباره سرپوش و خودرو: می‌توانید سرپوش و خودرو دریافت کنید، بسته به موقعیتی که کاربر در آن برنده شده است.<br/><br/>" +
      "- درباره نشان: نشان تنها در صورتی قابل دریافت است که امتیازات موقعیت کسب‌شده تکمیل شده باشد و نمی‌توان آن را با نشان دیگری تعویض کرد.<br/><br/>" +
      "- درباره سکه‌ها: در صورتی که کاربر یکی از رتبه‌ها را کسب کند، به عنوان مثال، اگر کاربر در رتبه اول قرار بگیرد اما امتیازات او ۵۰۰k باشد که کمتر از ۸۰۰k مورد نیاز برای دریافت سکه است، در این صورت او سرپوش رتبه اول + خودرو رتبه اول + نشان رتبه اول را دریافت می‌کند و همچنین می‌تواند سکه‌های رتبه دوم را دریافت کند، زیرا شرط امتیاز بیش از ۴۰۰k را دارد.<br/><br/>" +
      "- اما اگر کاربر در رتبه اول قرار بگیرد ولی امتیازات او کمتر از ۵۰۰k باشد، مثلاً ۴۰۰k که حتی کمتر از حداقل امتیاز نشان اول است، در این صورت فقط سرپوش و خودرو رتبه اول و سکه‌های رتبه دوم را دریافت می‌کند، یعنی بدون نشان.<br/><br/>" +
      "- کشورهای مختلف مانند ترکیه و عربستان دارای رتبه‌بندی‌های جداگانه‌ای هستند."
}



}



// WEBPACK FOOTER //
// src/pages/activity/weeklyStar/lang.js